module.exports = __webpack_public_path__ + "static/img/logo.9bd1455c.png";